module.exports = __webpack_public_path__ + "img/challenge-3-fr.5293cd37.png";